import { lazy, Suspense } from "react";
import { RouteObject } from "../../../helpers/tixxt-router";
import Loading from "../../shared/Loading";

const KnowledgeAssistant = lazy(() => import("./index"));
const KnowledgeAssistantHistoryPage = lazy(
  () => import("./KnowledgeAssistantHistoryPage"),
);
const SharedKnowledgeAssistantPage = lazy(
  () => import("./SharedKnowledgeAssistantPage"),
);

// Geteilter Chat (read-only) — Zugang über Token + Netzwerk-Anmeldung.
// Bewusst getrennt vom Default-Export: der Server liefert den geteilten Verlauf
// jedem angemeldeten Mitglied des Netzwerks aus (chats#shared hängt nur am
// netzwerkweiten Feature-Gate), während knowledge_assistant_available
// mitglieds-scoped ist. Wäre die Route mitgegated, liefe genau der Empfänger,
// dem man einen Chat schickt, weil er selbst keinen Assistenten hat, in eine
// leere Seite.
export const sharedRoutes: RouteObject[] = [
  {
    path: "/knowledge_assistant/shared/:token",
    element: (
      <Suspense fallback={<Loading />}>
        <SharedKnowledgeAssistantPage />
      </Suspense>
    ),
  },
];

const routes: RouteObject[] = [
  {
    path: "/knowledge_assistant",
    element: (
      <Suspense fallback={<Loading />}>
        <KnowledgeAssistant />
      </Suspense>
    ),
  },
  {
    path: "/knowledge_assistant/history",
    element: (
      <Suspense fallback={<Loading />}>
        <KnowledgeAssistantHistoryPage />
      </Suspense>
    ),
  },
];

export default routes;
